import { Box, BoxProps } from '@jfs/ui-new'
import Tab, { TabState } from '../Tab'
import { TabbarType } from '../Tabbar'

export const AdminPortalTabBar: React.FC<any> = ({ state, descriptors, navigation }: any) => {
  return (
    <Box {...styles.container}>
      {state.routes.map((route, index) => {
        const { options } = descriptors[route.key]
        const label =
          options.tabBarLabel !== undefined
            ? options.tabBarLabel
            : options.title !== undefined
            ? options.title
            : route.name

        const isFocused = state.index === index

        const onPress = () => {
          const event = navigation.emit({
            type: 'tabPress',
            target: route.key,
          })

          if (!isFocused && !event.defaultPrevented) {
            navigation.navigate(route.name)
          }
        }
        return (
          <Box {...styles.tabContainer}>
            <Tab
              title={label}
              state={isFocused ? TabState.selected : TabState.normal}
              type={TabbarType.recentPayments as any}
              onSelected={onPress}
            />
          </Box>
        )
      })}
    </Box>
  )
}

const styles = {
  container: {
    flexDirection: 'row',
    borderRadius: 4,
    borderColor: 'LIGHTEST_GREY',
    overflow: 'hidden',
    alignSelf: 'flex-start',
  } as BoxProps,
  tabContainer: {
    borderColor: 'LIGHTEST_GREY',
    flexDirection: 'row',
    flexWrap: 'wrap',
    borderWidth: 0.5,
  } as BoxProps,
}
